
export const Config = {
    // SiteUrl: "http://localhost:3000",
    // ApiUrl:"http://localhost:52376/api"
    SiteUrl: "https://hambley.me.uk/",
    ApiUrl: "https://hambley.me.uk/api"
}